module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"all":"所有評論","range":{"over":"{value} {unit} 以上","under":"{value} {unit} 以下","between":"{start} - {end} {unit}"}}}')
  delete Component.options._Ctor
}
